<div class="content-div popup-add-skills">
  <div class="top-bar">
    <span class="page-header"> {{ 'users:edituser_addSkillsTitle' | i18next }}</span>
    <span class="spacer"></span>
    <app-basic-button type="ghost" isIcon="true" size="medium" (click)="closeDialog()" aria-label="Close">
      <i class="far fa-times fs-16"></i>
    </app-basic-button>
  </div>

  <div class="content popup-add-skills-content">
    <div class="header-section">
      {{ 'realtime:usergroups_details_profile' | i18next }}: <span class="profile-name" *ngIf="profile">{{ profile.name
        }}</span>
      <div class="right">
        <app-filter-input id="filter-input-ongoing-requests" [(model)]="searchText" (modelChange)="onSearchChange()"
          [placeholder]="'users:Filter_categories_skills' | i18next" width="250px"></app-filter-input>
        <app-basic-button type="primary" size="medium" (click)="saveSkills()" [disabled]="!hasChanges()">{{
          'users:shared_confirmChanges' | i18next }}</app-basic-button>
      </div>
    </div>

    <!-- Skills List -->
    <div class="accordion-section" *ngFor="let service of services">

      <!-- Accordion Header -->
      <div class="accordion-header">
        <h3>
          {{ service.number }} {{ service.name }}
          <div class="info-icon">
            {{ 'users:newuser_skillsHeader' | i18next }}
          </div>
        </h3>
      </div>
      <!-- Accordion Body -->
      <div class="accordion-body">
        <div class="categorie" *ngFor="let category of service.categories">
          <div class="category-header" *ngIf="getSkillsForCategory(service.number, category.number).length > 0">
            <h4>
              {{ category.name=='shared_mediatype' ? ( 'users:shared_mediatype' | i18next ) : category.name }}
            </h4>
          </div>
          <div class="category-skills">
            <div class="skill" *ngFor="let skill of getSkillsForCategory(service.number, category.number)"
              [class.selected]="skill.isSelected">
              {{ skill.name }}
              <app-basic-textbox *ngIf="!skill.isSelected" [width]="'24px'" [size]="'x-small'" readonly="true"
                (click)="skill.isSelected = true;skill.userLevel = 9;"> </app-basic-textbox>
              <app-digit-dropdown [includeEmpty]="true" *ngIf="skill.isSelected" [(model)]="skill.userLevel"
                (modelChange)="onLevelChange(skill, $event)" [textboxWidth]="'24px'">
              </app-digit-dropdown>
            </div>
          </div>
          </div>
          </div>
          </div>
  </div>
</div>
